import * as z from "zod";

export const disconnectGoogleMerchantCenter = {
  name: "disconnectGoogleMerchantCenter" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
